import { render, staticRenderFns } from "./detailContent.vue?vue&type=template&id=2c08b196&scoped=true&"
import script from "./detailContent.vue?vue&type=script&lang=js&"
export * from "./detailContent.vue?vue&type=script&lang=js&"
import style0 from "./detailContent.vue?vue&type=style&index=0&id=2c08b196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08b196",
  null
  
)

export default component.exports